import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrSpinner } from './tr-spinner.component';

@NgModule({
    imports: [ CommonModule ],
    exports: [ TrSpinner ],
    declarations: [ TrSpinner ],
    entryComponents: [ TrSpinner ],
})
export class TrSpinnerModule {}
